
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";
import DispatchGuardTypes from "@/constants/DispatchGuardTypes";
import { Guard, GuardType } from '@/store/dispatch/types';

const Dispatch = namespace('dispatch');

@Component({})
export default class GuardTypeFilter extends Vue {
    @Dispatch.Getter('getGuardTypes') guardTypes!: GuardType[];
    @Dispatch.Action loadGuardTypes: any;

    @Prop({default: DispatchGuardTypes.Roaming})
    public guardTypeId: number;

    @Emit("guard-type-changed")
    public guardTypeChanged(guardTypeId: DispatchGuardTypes) {
        return guardTypeId;
    }

    async mounted() {
        if (!this.guardTypes) {
            await this.loadGuardTypes();
        }
    }

    private guardIconClass(guardTypeId: number) {
        const guardType = this.guardTypes.find(x => x.dispatchGuardTypeID == guardTypeId);
        if (guardType) {
            return guardType.dispatchIcon;
        }

        return "";
    }
}
